<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Requests'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Requests',
            includeDeleteAction: false
        };
    },

    computed: {
        options() {
            return {
                addButton: false
            };
        },

        labels() {
            return [
                { text: 'First name', value: 'user.firstName', width: '150px' },
                { text: 'Last name', value: 'user.lastName', width: '150px' },
                {
                    width: '150px',
                    text: "User's Campus",
                    sortable: false,
                    value: 'user.campuses',
                    filterFieldName: 'user.campuses.name',
                    filter: 'joinTable'
                },
                {
                    type: 'enum',
                    value: 'type',
                    enumOptions: ['reserve', 'mourning', 'birth'],
                    width: '150px'
                },
                {
                    type: 'number',
                    value: 'stars',
                    width: '130px'
                },
                {
                    type: 'enum',
                    value: 'status',
                    enumOptions: ['pending', 'accepted', 'rejected'],
                    width: '150px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'requests/index'
        }),

        onRowClick({ id }) {
            this.$router.push(`/requests/${id}/edit`);
        }
    }
};
</script>
